import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ProfileBanner } from "@edusense/user-ui";
// 기본 URL 상수 - 커버만 기본 제공 (프로필은 Avatar fallback 사용)
var DEFAULT_COVER_IMAGE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjQwMCIgdmlld0JveD0iMCAwIDEyMDAgNDAwIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNlMmU4ZjAiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNjYmQ1ZTEiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cGF0aCBmaWxsPSJ1cmwoI2EpIiBkPSJNMCAwaDEyMDB2NDAwSDB6Ii8+PC9zdmc+';
export var ProfileBannerSection = function(param) {
    var profile = param.profile, onGoBack = param.onGoBack, isMobileView = param.isMobileView, _param_editable = param.editable, editable = _param_editable === void 0 ? false : _param_editable, _param_isOwnProfile = param.isOwnProfile, isOwnProfile = _param_isOwnProfile === void 0 ? false : _param_isOwnProfile, _param_sessionProfileImage = param.sessionProfileImage, sessionProfileImage = _param_sessionProfileImage === void 0 ? null : _param_sessionProfileImage;
    var _profileData_basicInfo, _profileData_basicInfo1, _profileData_profileInfo;
    // useNavigate를 안전하게 처리 (Storybook 호환)
    var navigate;
    try {
        navigate = useNavigate();
    } catch (error) {
        navigate = function() {
            console.log('[ProfileBannerSection] Navigate called in Storybook environment');
        };
    }
    // 디버그 로그 제거
    var handleGoBack = function() {
        if (onGoBack) {
            onGoBack();
        } else {
            navigate(-1);
        }
    };
    // 날짜 포맷팅
    var formatJoinDate = function(dateString) {
        if (!dateString) return '';
        try {
            var date = new Date(dateString);
            return date.toLocaleDateString('ko-KR', {
                year: 'numeric',
                month: 'long'
            });
        } catch (e) {
            return '';
        }
    };
    var _profile_data;
    // 단일 경로 원칙: 응답 형태 정규화 (AxiosResponse.data 또는 직접 객체)
    var profileData = (_profile_data = profile === null || profile === void 0 ? void 0 : profile.data) !== null && _profile_data !== void 0 ? _profile_data : profile;
    var _profileData_username;
    var username = (_profileData_username = profileData === null || profileData === void 0 ? void 0 : profileData.username) !== null && _profileData_username !== void 0 ? _profileData_username : '';
    var _profileData_basicInfo_displayName, _ref;
    var displayName = (_ref = (_profileData_basicInfo_displayName = profileData === null || profileData === void 0 ? void 0 : (_profileData_basicInfo = profileData.basicInfo) === null || _profileData_basicInfo === void 0 ? void 0 : _profileData_basicInfo.displayName) !== null && _profileData_basicInfo_displayName !== void 0 ? _profileData_basicInfo_displayName : profileData === null || profileData === void 0 ? void 0 : profileData.displayName) !== null && _ref !== void 0 ? _ref : '';
    var _profileData_basicInfo_profileImageUrl;
    var profileImageUrl = isOwnProfile ? sessionProfileImage : (_profileData_basicInfo_profileImageUrl = profileData === null || profileData === void 0 ? void 0 : (_profileData_basicInfo1 = profileData.basicInfo) === null || _profileData_basicInfo1 === void 0 ? void 0 : _profileData_basicInfo1.profileImageUrl) !== null && _profileData_basicInfo_profileImageUrl !== void 0 ? _profileData_basicInfo_profileImageUrl : null;
    var _profileData_profileInfo_coverImageUrl;
    var coverImageUrl = (_profileData_profileInfo_coverImageUrl = profileData === null || profileData === void 0 ? void 0 : (_profileData_profileInfo = profileData.profileInfo) === null || _profileData_profileInfo === void 0 ? void 0 : _profileData_profileInfo.coverImageUrl) !== null && _profileData_profileInfo_coverImageUrl !== void 0 ? _profileData_profileInfo_coverImageUrl : null;
    return /*#__PURE__*/ React.createElement(ProfileBanner, {
        username: username,
        name: displayName,
        profileImage: profileImageUrl,
        coverImage: coverImageUrl !== null && coverImageUrl !== void 0 ? coverImageUrl : DEFAULT_COVER_IMAGE,
        isEditable: editable
    });
};
export default ProfileBannerSection;
